import UserSelectorTreeBuilderObserver from '../usersSelector/builder/UserSelectorTreeBuilderObserver'
import TreeNodeSet from '../hierarchySelector/tree/TreeNodeSet'

export default class ReportsUserSelectorTreeBuilderObserver extends UserSelectorTreeBuilderObserver {
    constructor({searchIndex, allActiveSet, manageableUsersIdsSet}) {
        super(searchIndex, allActiveSet)
        this.manageableUsersIdsSet = manageableUsersIdsSet
        this.manageableUsersNodeSet = new TreeNodeSet()
        this.accessibleParentNodes = new TreeNodeSet()
    }

    userNodeAdded(userNode) {
        super.userNodeAdded(userNode)

        const user = userNode.getValue();
        //null means all users are manageable
        if (this.manageableUsersIdsSet === null || this.manageableUsersIdsSet.has(user.id)) {
            this.manageableUsersNodeSet.add(userNode)
            this.accessibleParentNodes.add(userNode.getParent())
        }
    }

    getManageableUsersNodeSet() {
        return this.manageableUsersNodeSet
    }

    getAccessibleParentNodes() {
        return this.accessibleParentNodes
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/ReportsUserSelectorTreeBuilderObserver.js